import "@/styles/base.scss";
import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { useTelegramScreen } from "@/utils/hooks/useTelegramScreen";
import { useVersionCheck } from "@/utils/hooks/useVersionCheck";
import { useServiceTypeParam } from "@/utils/hooks/useServiceTypeParam";
import { ReferalsProvider } from "@/store/ReferalsProvider";
import { EarningsProvider } from "@/store/EarningsProvider";
import { ReferalProgramsProvider } from "@/store/ReferalProgramsProvider";
import { MultiplierProvider } from "@/store/MultiplierProvider";
import { MultiplierCelebrationDialog } from "@/pages/referralMultiplier/MultiplierCelebrationDialog";
import LoaderWrapper from "@/components/LoaderWrapper/LoaderWrapper";
import { ArrowIcon } from "@/assets/icons";
import cls from "./styles.module.scss";

export const App: FC = () => {
  useTelegramScreen();
  useVersionCheck();
  useServiceTypeParam();

  const searchParams = new URLSearchParams(window.location.search);
  const isOpenedFromKef = searchParams.get("source") === "kef";
  const kefPaddingTopParam = searchParams.get("tg_padding_top");
  const kefPaddingBottomParam = searchParams.get("tg_padding_bottom");
  const kefPaddingTop =
    kefPaddingTopParam === null ? null : Number(kefPaddingTopParam);
  const kefPaddingBottom =
    kefPaddingBottomParam === null ? null : Number(kefPaddingBottomParam);
  const telegramPaddingTop =
    isOpenedFromKef && kefPaddingTop !== null && Number.isFinite(kefPaddingTop)
      ? kefPaddingTop
      : 0;
  const telegramPaddingBottom =
    isOpenedFromKef &&
    kefPaddingBottom !== null &&
    Number.isFinite(kefPaddingBottom)
      ? kefPaddingBottom
      : 0;

  return (
    <ReferalsProvider>
      <ReferalProgramsProvider>
        <MultiplierProvider>
          <EarningsProvider>
            <MultiplierCelebrationDialog />
            <div className={cls.wrapper}>
              <LoaderWrapper>
                <div
                  className={cls.container}
                  style={
                    {
                      paddingTop: 24 + telegramPaddingTop,
                      paddingBottom: 24 + telegramPaddingBottom,
                      "--tg-padding-top": `${telegramPaddingTop}px`,
                      "--tg-padding-bottom": `${telegramPaddingBottom}px`,
                    } as React.CSSProperties
                  }
                >
                  {isOpenedFromKef && (
                    <button
                      type="button"
                      data-trigger="ref.main.back_to_kef"
                      className={cls.kefBackBtn}
                      onClick={() => window.history.back()}
                      aria-label="Назад к кэфам"
                    >
                      <ArrowIcon />
                      <span>Назад к кэфам</span>
                    </button>
                  )}
                  <Outlet />
                </div>
              </LoaderWrapper>
            </div>
          </EarningsProvider>
        </MultiplierProvider>
      </ReferalProgramsProvider>
    </ReferalsProvider>
  );
};
